import { useQuery } from "@tanstack/react-query";

import { ListPromocodeBatchesQueryFilters, UseListPromocodeBatchesQueryOptions } from "./types";
import { getPromocodeBatchesService } from "./service";

export const listPromocodeBatchesQueryKey = ["promocode_batch_admin"];

export function useListPromocodeBatchesQuery(
  filters?: ListPromocodeBatchesQueryFilters,
  options?: UseListPromocodeBatchesQueryOptions
) {
  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listPromocodeBatchesQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getPromocodeBatchesService(filters),
    ...options,
  });
}
